
import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/*
|--------------------------------------------------------------------------
| CLASSES
|--------------------------------------------------------------------------
*/

export const createClass = async (data) => {
  const { data: res } = await axiosInstance.post("/classes/create", data);
  return res;
};

export const getAllClasses = async () => {
  const { data } = await axiosInstance.get("/classes/all");
  return data;
};

export const updateClass = async (id, data) => {
  const { data: res } = await axiosInstance.put(`/classes/${id}`, data);
  return res;
};

/*
|--------------------------------------------------------------------------
| SECTIONS
|--------------------------------------------------------------------------
*/

export const createSection = async (data) => {
  const { data: res } = await axiosInstance.post("/sections/create", data);
  return res;
};

export const getAllSections = async (classId) => {
  const url = classId ? `/sections/all?classId=${classId}` : "/sections/all";
  const { data } = await axiosInstance.get(url);
  return data;
};

export const updateSection = async (id, data) => {
  const { data: res } = await axiosInstance.put(`/sections/${id}`, data);
  return res;
};
/*
|--------------------------------------------------------------------------
| CREDENTIALS — Owner
|--------------------------------------------------------------------------
*/

export const regenerateCredentials = async (id) => {
  const { data } = await axiosInstance.post(`/admin-students/regenerate-credentials-owner/${id}`);
  return data;
};


/*
|--------------------------------------------------------------------------
| STUDENTS
|--------------------------------------------------------------------------
*/

export const createStudent = async (data) => {
  const { data: res } = await axiosInstance.post("/students/create", data);
  return res;
};

export const getAllStudents = async (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  const { data } = await axiosInstance.get(`/students/all?${params}`);
  return data;
};

export const getStudentById = async (id) => {
  const { data } = await axiosInstance.get(`/students/${id}`);
  return data;
};

export const updateStudent = async (id, data) => {
  const { data: res } = await axiosInstance.put(`/students/update/${id}`, data);
  return res;
};

export const updateStudentStatus = async (id, status) => {
  const { data } = await axiosInstance.put(`/students/status/${id}`, { status });
  return data;
};
